// extracted by mini-css-extract-plugin
module.exports = {"svg-style":"_1yLZU"};